<template>
  <v-tab-item key="4">
    <v-row no-gutters justify="space-between">
      <h4>Total {{ sessionList.length }} sessions</h4>
      <v-btn
        text
        class="pa-0 font700 h-auto"
        color="#58e2c2"
        :ripple="false"
        :disabled="!canClearSessions"
        :data-test-id="`${dataTestId}__clear-section-btn`"
        @click="clearSessions"
      >
        Clear Sessions
      </v-btn>
    </v-row>
    <div :data-test-id="`${data-test-id}__session-list`">
      <div class="mt-4" v-for="(session, index) in sessionList" :key="index" :data-test-id="`${dataTestId}__session-list-item-${index + 1}`">
        <v-row no-gutters justify="space-between" align="center">
          <div>
            <div>
              <span>{{ session.sessionId }}</span>
            </div>
            <div class="font10">
              <span
                v-if="session.sessionId === sessionId"
                class="active-session font700"
              >
                Current Session
              </span>
              <span v-else class="session-date">
                {{ getFormatedDateAsPerTimeZone(session.lastAccess) }}
              </span>
              <span>•</span>
              <span class="device-name">{{ session.ipAddress }}</span>
            </div>
          </div>
          <div>
            <v-icon
              v-if="session.sessionId !== sessionId"
              color="red"
              size="18"
              :data-test-id="`${dataTestId}__session-list-item-${index + 1}__delete-session-btn`"
              @click="clearSession(session, index)"
            >
              delete
            </v-icon>
          </div>
        </v-row>
      </div>
    </div>
    <div class="mt-4">
      <v-skeleton-loader
        v-if="!sessionList.length"
        type="list-item-two-line"
      ></v-skeleton-loader>
    </div>
  </v-tab-item>
</template>
<script>
import UserService from '../../../services/UserService';
import { mapState } from 'vuex';
export default {
  data() {
    return { sessionList: [] };
  },
  computed: {
    ...mapState(['sessionId']),
    canClearSessions() {
      return this.sessionList.length > 1;
    }
  },
  props: {
    userId: String,
    dataTestId: String
  },
  mounted() {
    this.getSessionList();
  },
  methods: {
    // get user's session list
    async getSessionList() {
      try {
        const response = await UserService.getUserSessions(this.userId);
        if (this.parseResponse(response)[0]) {
          this.sessionList = this.parseResponse(response)[0];
        } else {
          this.snackbar('error', this.$message.ERROR);
        }
      } catch (err) {
        console.log('error', err);
        this.snackbar('error', this.$message.ERROR);
      }
    },
    // clear user's sessions
    async clearSessions() {
      try {
        await UserService.deleteSessions(this.userId, {
          params: { sessionId: this.sessionId }
        });
        this.sessionList = this.sessionList.filter(
          session => session.sessionId === this.sessionId
        );
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    /**
     * clear user's session using index
     * @param {Object} session
     * @param {Number} index
     */
    async clearSession(session, index) {
      try {
        if (session.sessionId === this.sessionId) {
          await this.logoutUser();
        } else {
          await UserService.deleteSession(this.userId, session.sessionId);
        }
        this.sessionList.splice(index, 1);
      } catch {
        this.snackbar('error', this.$message.ERROR);
      }
    }
  }
};
</script>
